import { CompanyLicense } from '../../../../models/company-license.model';

export const convertLicensesToGet = (licenses: CompanyLicense): CompanyLicense => {
  return new CompanyLicense(licenses);
};
